import React from 'react'
import SearchTabsEventsSugar from '../../components/searchTabsEventsSugar/SearchTabsEventsSugar'
import SearchTopBoxAuthor from '../../components/searchtopboxAuthor/SearchTopBoxAuthor'

const Search = () => {
  return (
    <div className='dashboard-content-box'>
       <div className='searchbox-header-top-box'>
        <SearchTopBoxAuthor />
       </div>
       <div className='search-box-bottom  fixed-padding search-tabs-events-sugar'>
          <SearchTabsEventsSugar />
       </div>
    </div>
  )
}

export default Search
